<template>
  <div v-if="url">
    <div v-if="isPlay" class="music-play-icon" @click="pauseMusic">
      <iconpark-icon name="pause"></iconpark-icon>
    </div>
    <div v-else class="music-play-icon" @click="playMusic">
      <iconpark-icon name="play"></iconpark-icon>
    </div>
    <audio
      :id="`audio${id}`"
      ref="audioRef"
      controls
      class="hidden"
      @ended="pauseMusic"
      @play="checkPlay(true)"
      @pause="checkPlay(false)"
    >
      <source :src="url" />
    </audio>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ url?: string; id: number }>()

const audioRef = ref()

const isPlay = ref(false)

const checkPlay = (play: boolean) => {
  isPlay.value = play
}

// 暂停播放
const pauseMusic = () => {
  audioRef.value?.pause()
}
// 只允许一个音频播放
const playMusic = () => {
  const videoElement = document.getElementsByTagName('audio')
  Array.from(videoElement).forEach((item) => {
    if (item.id === 'audio' + props.id) {
      item.play()
    } else {
      item.pause()
    }
  })
}
</script>

<style lang="scss" scoped>
.music-play-icon {
  @apply absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] hover:bg-back-5;
  display: flex;
  height: 40px;
  width: 40px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  text-align: center;
  color: var(--primary-color);
  background: var(--back-2);
}
</style>
